import styled from '@emotion/styled';

export const MarkerDetailContent = styled('div')(() => ({
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '10px',
  fontSize: '14px',
}));
